var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2L11 2V1.5C11 0.7 10.3 0 9.5 0L5.5 0C4.7 0 4 0.7 4 1.5V2L0 2L0 3H1L1.4 14.6C1.5 15.4 2.2 16 3 16L12 16C12.8 16 13.5 15.4 13.5 14.6L14 3H15V2ZM5 1.5C5 1.2 5.2 1 5.5 1L9.5 1C9.8 1 10 1.2 10 1.5V2L5 2V1.5ZM12.5 14.5C12.5 14.8 12.3 15 12 15L3 15C2.7 15 2.5 14.8 2.5 14.5L2 3L13 3L12.5 14.5Z",
    fill: "#005F87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 13L5 5H4L4.3 13H5.3Z",
    fill: "#005F87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5H7L7 13L8 13L8 5Z",
    fill: "#005F87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 13L11 5L10 5L9.8 13H10.8Z",
    fill: "#005F87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2dbab6f4e88fed46013c12a11c1fe823.svg";
export { ForwardRef as ReactComponent };